export default __webpack_public_path__ + "static/tooltip-interactive-1-do-dark-ae8a7e25da9368025fe38e5b63a5730631d9656eff02678e66d7dff357009fee.png";